(() => {
  angular.module('app').component('hostCorporatesCreateEditCreditLimit', {
    templateUrl: require('./widget.html'),
    controller: CorporateEditCreditLimitController,
    controllerAs: 'vm',
    bindings: {
      corporateId: '<',
      currencyCode: '<',
      canEdit: '<',
    },
  });

  CorporateEditCreditLimitController.$inject = ['$uibModal', 'abp.services.app.creditLimit'];

  function CorporateEditCreditLimitController($uibModal, creditLimitSvc) {
    const vm = this;

    vm.loading = 0;

    // Null until loaded, so the limits stay blank and editing waits for the real values.

    vm.creditLimit = null;

    vm.viewHistory = viewHistory;
    vm.editPermanentLimit = editPermanentLimit;
    vm.grantTemporaryLimit = grantTemporaryLimit;
    vm.revokeGrant = revokeGrant;
    vm.$onChanges = onChanges;

    // The container sets corporateId after loading the corporate, so load once it arrives.

    function onChanges(changes) {
      if (changes.corporateId && vm.corporateId) {
        getCreditLimit();
      }
    }

    function getCreditLimit() {
      vm.loading += 1;
      creditLimitSvc
        .getCreditLimit({ id: vm.corporateId })
        .success((data) => {
          vm.creditLimit = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    // Every change to the limit, newest first. Read only, so nothing reloads afterwards.

    function viewHistory() {
      $uibModal.open({
        templateUrl: require('./creditLimitHistory.modal.html'),
        controller: 'host.views.corporates.createEdit.creditLimit.creditLimitHistory as vm',
        size: 'xl',
        resolve: {
          corporateId: () => vm.corporateId,
          currencyCode: () => vm.currencyCode,
        },
      });
    }

    // Change the permanent limit. The modal sends back the permanent limit shown here, so the
    // server can reject the save if someone else changed it. Reload whether the modal is saved
    // or cancelled, so after such a rejection the next attempt starts from the current limit.

    function editPermanentLimit() {
      $uibModal
        .open({
          templateUrl: require('./permanentLimitEdit.modal.html'),
          controller: 'host.views.corporates.createEdit.creditLimit.permanentLimitEdit as vm',
          backdrop: 'static',
          resolve: {
            corporateId: () => vm.corporateId,
            currencyCode: () => vm.currencyCode,
            currentPermanentLimit: () => vm.creditLimit.permanentLimit,
          },
        })
        .result.then(getCreditLimit, getCreditLimit);
    }

    // Grant a temporary limit on top of the permanent one. Reload whether the modal is saved or
    // cancelled, the same as editing the permanent limit, so the card shows any grant or change
    // made in the meantime.

    function grantTemporaryLimit() {
      $uibModal
        .open({
          templateUrl: require('./grantTemporaryLimit.modal.html'),
          controller: 'host.views.corporates.createEdit.creditLimit.grantTemporaryLimit as vm',
          backdrop: 'static',
          resolve: {
            corporateId: () => vm.corporateId,
            currencyCode: () => vm.currencyCode,
          },
        })
        .result.then(getCreditLimit, getCreditLimit);
    }

    // Revoke this one active grant before it expires. Reload whether the modal is saved or
    // cancelled, the same as the other two, so the card drops a grant that has since ended.

    function revokeGrant(grant) {
      $uibModal
        .open({
          templateUrl: require('./revokeTemporaryGrant.modal.html'),
          controller: 'host.views.corporates.createEdit.creditLimit.revokeTemporaryGrant as vm',
          backdrop: 'static',
          resolve: {
            grant: () => grant,
            currencyCode: () => vm.currencyCode,
          },
        })
        .result.then(getCreditLimit, getCreditLimit);
    }
  }
})();
